import boletaApi from "./boletaApi";

export const deleteEmployee = async (body) => {
  try {
    return await boletaApi.post("/deleteEmployee", body);
  } catch (error) {
    const { response } = error;
    return response;
  }
};
